"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.search");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _Transfer = _interopRequireDefault(require("@/components/Transfer"));
var _vuex = require("vuex");
var _bankSlipUploadDlg = _interopRequireDefault(require("./components/bankSlipUploadDlg"));
var _bankSlipUploadDlgKR = _interopRequireDefault(require("./components/bankSlipUploadDlgKR"));
var _invoiceApplyDlg = _interopRequireDefault(require("./components/invoiceApplyDlg"));
var _uploadInvoiceDlg = _interopRequireDefault(require("./components/uploadInvoiceDlg"));
var _exportCostSlipUpload = require("@/api/exportCostSlipUpload/exportCostSlipUpload");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _indexAmountButton = _interopRequireDefault(require("./components/indexAmountButton.vue"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "exportCostSlipUpload",
  components: {
    buttonRenderer: _indexAmountButton.default,
    sailSchedule: _SailScheduleOne.default,
    Pagination: _Pagination.default,
    bankSlipUploadDlg: _bankSlipUploadDlg.default,
    bankSlipUploadDlgKR: _bankSlipUploadDlgKR.default,
    invoiceApplyDlg: _invoiceApplyDlg.default,
    uploadInvoiceDlg: _uploadInvoiceDlg.default,
    Transfer: _Transfer.default,
    filterColumn: _index.default,
    customRenderer: _indexHotOpt.default
  },
  data: function data() {
    return {
      supplyInvoice: false,
      showSupplyButton: false,
      showSingleButton: '',
      feeStatusList: [],
      bankSlipStatusList: [],
      applyInvoiceStatusList: [],
      formDialog: {},
      invoiceData: {},
      companyName: "",
      pol: "",
      idBlNos: "",
      targetDataOne: [],
      sourceData: [],
      tableKey: 0,
      transferDialogVisible: false,
      total: 0,
      dataTime: [],
      listQuery: {
        vesselCode: "",
        voyageNo: "",
        voyageLeg: "",
        fromDate: "",
        toDate: "",
        bkNo: "",
        blNo: "",
        feeStatus: "",
        bankSlipStatus: "",
        applyInvoiceStatus: "",
        pol: "",
        pod: "",
        pageStart: 1,
        pageSize: 10
      },
      loading: null,
      tableData: [],
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 480px)',
        width: 'auto',
        overflow: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      sailScheduleDialogVisible: false,
      bankSlipUploadDlgVisible: false,
      bankSlipUploadDlgKRVisible: false,
      invoiceApplyDlgVisible: false,
      uploadInvoiceDlgVisible: false,
      rules: {
        pol: [{
          required: true,
          message: this.$t('exportCostSlipUpload.polNotNull'),
          trigger: 'blur'
        }],
        vvl: [{
          validator: this.validateVvl,
          trigger: 'blur'
        }, {
          validator: this.validateVvl,
          trigger: 'change'
        }],
        bkNo: [{
          validator: this.validateBkNo,
          trigger: 'blur'
        }, {
          validator: this.validateBkNo,
          trigger: 'change'
        }],
        blNo: [{
          validator: this.validateBlNo,
          trigger: 'blur'
        }, {
          validator: this.validateBlNo,
          trigger: 'change'
        }],
        dataTime: [{
          validator: this.validateDataTime,
          trigger: 'blur'
        }, {
          validator: this.validateDataTime,
          trigger: 'change'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    this.loading = (0, _utils.load)();
    this.$dictionary.get(['DOC_FEES_STATE', 'DOC_BANK_SLIP_STATE', 'DOC_INVOICE_STATE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.feeStatusList = res.DOC_FEES_STATE ? res.DOC_FEES_STATE : [];
      _this.bankSlipStatusList = res.DOC_BANK_SLIP_STATE ? res.DOC_BANK_SLIP_STATE : [];
      _this.applyInvoiceStatusList = res.DOC_INVOICE_STATE ? res.DOC_INVOICE_STATE : [];
    }).finally(function () {
      _this.loading.close();
    });
    this.initData();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.defaultTime();
      _this2.resizeHotTable();
    });
  },
  methods: {
    hotTableSelect: function hotTableSelect(data) {
      var selectTableData = this.$refs.hotTable.getSelections();
      if (selectTableData.every(function (item) {
        return !(0, _validate.validateNull)(item.invoiceState);
      }) && selectTableData.every(function (item) {
        return (0, _validate.validateNull)(item.bankSlipState);
      })) {
        this.showSupplyButton = true;
      } else {
        this.showSupplyButton = false;
      }
    },
    //装货港=CNSHK/CNCAN的时候 把按钮【水单上传】【开票申请】置灰
    //装货港<>CNSHK/CNCAN的时候把按钮【水单上传/开票申请】置灰
    judgePort: function judgePort(value) {
      value === 'CNSHK' || value === 'CNCAN' || value === 'CNNSA' || value === 'CNYPG' ? this.showSingleButton = false : this.showSingleButton = true;
    },
    defaultTime: function defaultTime() {
      var now = new Date();
      var startDate = new Date();
      startDate.setDate(now.getDate() - 15);
      var endDate = new Date();
      endDate.setDate(now.getDate() + 15);
      var formatDate = function formatDate(date) {
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, '0');
        var day = date.getDate().toString().padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      };
      this.listQuery.fromDate = formatDate(startDate);
      this.listQuery.toDate = formatDate(endDate);
      this.dataTime = [formatDate(startDate), formatDate(endDate)];
    },
    handleCloseUploadInvoiceDlg: function handleCloseUploadInvoiceDlg() {
      this.uploadInvoiceDlgVisible = false;
      this.handleSearch();
    },
    handleCloseBankSlipUploadDlg: function handleCloseBankSlipUploadDlg() {
      this.bankSlipUploadDlgVisible = false;
      this.handleSearch();
    },
    handleCloseBankSlipUploadDlgKR: function handleCloseBankSlipUploadDlgKR() {
      this.bankSlipUploadDlgKRVisible = false;
      this.handleSearch();
    },
    handleCloseInvoiceApplyDlg: function handleCloseInvoiceApplyDlg() {
      this.invoiceApplyDlgVisible = false;
      this.handleSearch();
    },
    initData: function initData() {
      this.sourceData = [{
        data: 'amount',
        title: this.$t('exportCostSlipUploadTable.amount')
      }, {
        data: 'feesState',
        title: this.$t('exportCostSlipUploadTable.feeState'),
        tableListNY: true
      }, {
        data: 'bankSlipState',
        title: this.$t('exportCostSlipUploadTable.bankSlipState'),
        tableListNX: true
      }, {
        data: 'paymentStatus',
        title: this.$t('exportCostSlipUploadTable.paymentStatus'),
        tableListPS: true
      }, {
        data: 'invoiceState',
        title: this.$t('exportCostSlipUploadTable.applyInvoiceState'),
        tableListNC: true
      }, {
        data: 'bkNo',
        title: this.$t('exportCostSlipUploadTable.bkNo')
      }, {
        data: 'blNo',
        title: this.$t('exportCostSlipUploadTable.blNo')
      }, {
        data: 'vesselCode',
        title: this.$t('exportCostSlipUploadTable.vesselCode')
      }, {
        data: 'voyageNo',
        title: this.$t('exportCostSlipUploadTable.voyageNo')
      }, {
        data: 'voyageLeg',
        title: this.$t('exportCostSlipUploadTable.voyageLeg')
      }, {
        data: 'pol',
        title: this.$t('exportCostSlipUploadTable.pol')
      }, {
        data: 'etd',
        title: this.$t('exportCostSlipUploadTable.etdOrg')
      }, {
        data: 'pod',
        title: this.$t('exportCostSlipUploadTable.pod')
      }, {
        data: 'eta',
        title: this.$t('exportCostSlipUploadTable.eta')
      },
      // { data: 'etd', title:this.$t('exportCostSlipUploadTable.etd') },
      {
        data: 'del',
        title: this.$t('exportCostSlipUploadTable.del')
      }, {
        data: 'bankSlipAuditRemark',
        title: this.$t('exportCostSlipUploadTable.auditRemark')
      }, {
        data: 'invoicingApplicationAuditRemark',
        title: this.$t('exportCostSlipUploadTable.auditRemark2')
      }];
      this.targetDataOne = [{
        data: 'feesStateListId',
        title: 'feesStateListId'
      }, {
        data: 'paymentWay',
        title: 'paymentWay'
      }, {
        data: 'attachment',
        title: 'attachment',
        isShow: true
      }, {
        data: 'amount2',
        title: 'amount2'
      }, {
        data: 'companyName',
        title: 'companyName'
      }];
      this.tableKey += 1;
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
      // this.$nextTick(() => {
      //    this.handleSearch()
      // });
    },
    handleSortOpen: function handleSortOpen() {
      console.log('this.sourceData', this.sourceData);
      this.transferDialogVisible = true;
    },
    handleSubimtSort: function handleSubimtSort(data) {
      console.log('data', data);
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      this.handleSearch();
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    searchFn: function searchFn(val) {
      this.listQuery.pageStart = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this3 = this;
      if (!Array.isArray(this.dataTime) || this.listQuery.length == 0) {
        this.listQuery.fromDate = '';
        this.listQuery.toDate = '';
      }
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this3.listQuery));
          _this3.loading = (0, _utils.load)();
          (0, _exportCostSlipUpload.search)(data).then(function (res) {
            if (res.success) {
              _this3.tableData = res.data.records;
              _this3.tableData.forEach(function (item) {
                item.eta = item.eta ? item.eta.slice(0, 10) : item.eta;
                item.etd = item.etd ? item.etd.slice(0, 10) : item.etd;
              });
              console.log(_this3.tableData, '9999');
              _this3.total = res.data.totalRecord;
            } else {
              _this3.$message({
                message: res.errorMessages[0],
                type: 'error'
              });
            }
          }).finally(function () {
            _this3.loading.close();
          });
        }
      });
      console.log(this.listQuery);
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      this.listQuery.vesselCode = row.vesselCode;
      this.listQuery.vesselName = row.vesselName;
      this.listQuery.voyageLeg = row.voyageLeg;
      this.listQuery.voyageNo = row.voyageNo;
    },
    handleChangeTime: function handleChangeTime() {
      if (!this.dataTime || this.dataTime.length <= 1) {
        return;
      }
      var fromDate = new Date(this.dataTime[0]);
      var toDate = new Date(this.dataTime[1]);
      var diffTime = Math.abs(toDate - fromDate);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert milliseconds to days

      if (diffDays > 31) {
        this.$message.error(this.$t('exportCostSlipUpload.timeFrame'));
        this.dataTime = [];
      } else {
        this.listQuery.fromDate = this.dataTime[0];
        this.listQuery.toDate = this.dataTime[1];
      }
    },
    handleOpenVesselSearch: function handleOpenVesselSearch() {
      this.sailScheduleDialogVisible = true;
    },
    handleReset: function handleReset() {
      for (var key in this.listQuery) {
        this.listQuery[key] = '';
      }
      this.defaultTime();
      this.listQuery.pageStart = 1;
      this.listQuery.pageSize = 10;
    },
    handleFeeConfirmation: function handleFeeConfirmation() {
      var _this4 = this;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('exportCostSlipUpload.pleaseCheckData'));
        return;
      }
      var _iterator = (0, _createForOfIteratorHelper2.default)(hotTableSelections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rowData = _step.value;
          if (!rowData.feesState || rowData.feesState == '01') {
            this.$message.error(this.$t('exportCostSlipUpload.costStatusDetermination'));
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var feesStateListIds = hotTableSelections.map(function (select) {
        return select.feesStateListId;
      });
      var data = JSON.parse(JSON.stringify(feesStateListIds));
      this.loading = (0, _utils.load)();
      (0, _exportCostSlipUpload.updateFeeState)(data).then(function (res) {
        if (res.success) {
          _this4.$message.success(_this4.$t('exportCostSlipUpload.costStatusChange'));
          _this4.handleSearch();
        } else {
          _this4.$message({
            message: res.errorMessages[0],
            type: 'error'
          });
        }
      }).finally(function () {
        _this4.loading.close();
      });
    },
    handleBankSlipUpload: function handleBankSlipUpload() {
      var _this5 = this;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (!this.validateSelections(hotTableSelections)) {
        return;
      }
      var KRXXXFlag = false;
      if (hotTableSelections.some(function (item) {
        return item.pol.startsWith('KR');
      })) {
        KRXXXFlag = true;
      }
      var idBlNos = hotTableSelections.map(function (select) {
        return select.feesStateListId + "/" + select.blNo;
      }).join(',');
      var amountStr = hotTableSelections.map(function (select) {
        return select.amount2;
      }).join(',');
      var object = {
        amountStr: amountStr,
        idBlNos: idBlNos
      };
      this.idBlNos = idBlNos;
      this.loading = (0, _utils.load)();
      if (KRXXXFlag) {
        //韩国 KR
        (0, _exportCostSlipUpload.openDialogKR)(object).then(function (res) {
          if (res.success) {
            _this5.formDialog = res.data;
            _this5.companyName = hotTableSelections[0].companyName;
            _this5.bankSlipUploadDlgKRVisible = true;
          }
        }).finally(function () {
          _this5.loading.close();
        });
      } else {
        (0, _exportCostSlipUpload.openDialog)(object).then(function (res) {
          if (res.success) {
            _this5.formDialog = res.data;
            _this5.companyName = hotTableSelections[0].companyName;
            _this5.bankSlipUploadDlgVisible = true;
          }
        }).finally(function () {
          _this5.loading.close();
        });
      }
    },
    handleApplyInvoice: function handleApplyInvoice() {
      var _this6 = this;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (!this.validateSelections(hotTableSelections)) {
        return;
      }

      //只有状态=空、拒绝、才能进行开票申请
      if (hotTableSelections.some(function (item) {
        return item.invoiceState != null && item.invoiceState !== '02';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.invoiceStateValidate1'));
        return;
      }
      var idBlNos = hotTableSelections.map(function (select) {
        return select.feesStateListId + "/" + select.blNo;
      }).join(',');
      ;
      var amountStr = hotTableSelections.map(function (select) {
        return select.amount2;
      }).join(',');
      var object = {
        amountStr: amountStr,
        idBlNos: idBlNos
      };
      var invoiceObject = {
        idBlNos: idBlNos
      };
      this.idBlNos = idBlNos;
      this.loading = (0, _utils.load)();
      (0, _exportCostSlipUpload.openDialog)(object).then(function (res) {
        if (res.success) {
          _this6.formDialog = res.data;
          _this6.companyName = hotTableSelections[0].companyName;
          (0, _exportCostSlipUpload.searchInvoice)(invoiceObject).then(function (res) {
            if (res.success) {
              _this6.invoiceData = res.data;
            } else {
              _this6.$message.warning(res.errorMessages[0]);
            }
            console.log(res);
          });
          _this6.invoiceApplyDlgVisible = true;
        } else {
          _this6.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this6.loading.close();
      });
    },
    handleUploadInvoicePlus: function handleUploadInvoicePlus() {
      var _this7 = this;
      this.supplyInvoice = true;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('exportCostSlipUpload.pleaseCheckData'));
        return false;
      }
      if (hotTableSelections.length > 10) {
        this.$message.error(this.$t('importBillUpload.limit10Data'));
        return;
      }
      //eb.OnlyCnshkUse=该页面仅限蛇口（深圳）使用
      //eb.OnlyCnshkUse=This page is only for use by Shekou (Shenzhen)
      if (hotTableSelections.some(function (item) {
        return item.pol !== 'CNSHK' && item.pol !== 'CNNSA' && item.pol !== 'CNYPG';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.onlyCnshkUse'));
        return false;
      }
      if (hotTableSelections.some(function (item) {
        return !item.blNo || item.feesState != '01';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.blNoFeesStateValidate'));
        return false;
      }
      if (hotTableSelections.some(function (item) {
        return item.paymentStatus === 1;
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.paymentStatusValidate'));
        return false;
      }
      var idBlNos = hotTableSelections.map(function (select) {
        return select.feesStateListId + "/" + select.blNo;
      }).join(',');
      ;
      var amountStr = hotTableSelections.map(function (select) {
        return select.amount2;
      }).join(',');
      this.loading = (0, _utils.load)();
      (0, _exportCostSlipUpload.openDialogSHK)(amountStr, idBlNos).then(function (res) {
        if (res.success) {
          _this7.formDialog = res.data;
          _this7.idBlNos = idBlNos;
          _this7.companyName = hotTableSelections[0].companyName;
          _this7.pol = hotTableSelections[0].pol;
          (0, _exportCostSlipUpload.searchInvoiceShk)(idBlNos).then(function (res) {
            if (res.success) {
              _this7.invoiceData = res.data;
              _this7.uploadInvoiceDlgVisible = true;
            }
          });
        }
      }).finally(function () {
        _this7.loading.close();
      });
    },
    handleUploadInvoice: function handleUploadInvoice() {
      var _this8 = this;
      this.supplyInvoice = false;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('exportCostSlipUpload.pleaseCheckData'));
        return false;
      }
      if (hotTableSelections.length > 10) {
        this.$message.error(this.$t('importBillUpload.limit10Data'));
        return;
      }
      //eb.OnlyCnshkUse=该页面仅限蛇口（深圳）使用
      //eb.OnlyCnshkUse=This page is only for use by Shekou (Shenzhen)
      if (hotTableSelections.some(function (item) {
        return item.pol !== 'CNSHK' && item.pol !== 'CNNSA' && item.pol !== 'CNYPG';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.onlyCnshkUse'));
        return false;
      }
      if (hotTableSelections.some(function (item) {
        return !item.blNo || item.feesState != '01';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.blNoFeesStateValidate'));
        return false;
      }
      if (hotTableSelections.some(function (item) {
        return item.invoiceState === '01';
      })) {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: this.$t('exportCostSlipUpload.invoiceStateAcceptValidate')
        });
        return false;
      }
      if (hotTableSelections.some(function (item) {
        return item.invoiceCount > 0;
      })) {
        this.$message.error(this.$t('importBillUpload.noSecondOpr'));
        return false;
      }
      var idBlNos = hotTableSelections.map(function (select) {
        return select.feesStateListId + "/" + select.blNo;
      }).join(',');
      ;
      var amountStr = hotTableSelections.map(function (select) {
        return select.amount2;
      }).join(',');
      this.loading = (0, _utils.load)();
      (0, _exportCostSlipUpload.openDialogSHK)(amountStr, idBlNos).then(function (res) {
        if (res.success) {
          _this8.formDialog = res.data;
          _this8.idBlNos = idBlNos;
          _this8.companyName = hotTableSelections[0].companyName;
          _this8.pol = hotTableSelections[0].pol;
          (0, _exportCostSlipUpload.searchInvoiceShk)(idBlNos).then(function (res) {
            if (res.success) {
              _this8.invoiceData = res.data;
              _this8.uploadInvoiceDlgVisible = true;
            }
          });
        }
      }).finally(function () {
        _this8.loading.close();
      });
    },
    validateSelections: function validateSelections(selections) {
      if (selections.length === 0) {
        this.$message.error(this.$t('exportCostSlipUpload.pleaseCheckData'));
        return false;
      }
      //装货港为CNCAN/CNSHK，请在“水单上传/开票申请”操作
      if (selections.some(function (item) {
        return item.pol === 'CNSHK' || item.pol === 'CNCAN';
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.cnshkAndCncanValidate'));
        return false;
      }
      if (selections.some(function (item) {
        return (!item.blNo || item.feesState !== '01') && !item.pol.startsWith("KR");
      })) {
        this.$message.error(this.$t('exportCostSlipUpload.blNoFeesStateValidate'));
        return false;
      }
      // 去掉开票申请对水单状态的校验
      // if (selections.some(item => item.bankSlipState === '01' || item.bankSlipState === '04')) {
      //   this.$message.error(this.$t('exportCostSlipUpload.bankSlipNotArrive'));
      //   return false;
      // }
      return true;
    },
    feesStateRenderer: function feesStateRenderer(instance, td, row, col, prop, value, cellProperties) {
      if (value == "00") {
        td.innerHTML = '待确认';
      } else if (value == "01") {
        td.innerHTML = '已确认';
      } else if (value == "02") {
        td.innerHTML = '有变更';
      } else {
        td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    bankSlipStateRenderer: function bankSlipStateRenderer(instance, td, row, col, prop, value, cellProperties) {
      if (value == "00") {
        td.innerHTML = '已提交';
      } else if (value == "01") {
        td.innerHTML = '接受';
      } else if (value == "03") {
        td.innerHTML = '不通过';
      } else if (value == "02") {
        td.innerHTML = '有变更';
      } else {
        td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    invoiceStateRenderer: function invoiceStateRenderer(instance, td, row, col, prop, value, cellProperties) {
      if (value == "00") {
        td.innerHTML = '申请';
      } else if (value == "01") {
        td.innerHTML = '接受';
      } else if (value == "02") {
        td.innerHTML = '拒绝';
      } else if (value == "03") {
        td.innerHTML = '有变更';
      } else {
        td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    validateVvl: function validateVvl(rule, value, callback) {
      if (this.listQuery.vesselCode === '' || this.listQuery.voyageNo === '' || this.listQuery.voyageLeg === '') {
        if ((this.dataTime === null || this.dataTime.length === 0) && (0, _validate.validateNull)(this.listQuery.bkNo) && (0, _validate.validateNull)(this.listQuery.blNo)) {
          callback(new Error(this.$t('exportCostSlipUpload.inputVvlOrDataTime')));
        } else {
          callback();
        }
      } else {
        // this.$refs.filterForm.validateField('dataTime')
        callback();
      }
    },
    validateBkNo: function validateBkNo(rule, value, callback) {
      if ((0, _validate.validateNull)(this.listQuery.bkNo)) {
        if ((this.dataTime === null || this.dataTime.length === 0) && (this.listQuery.vesselCode === '' || this.listQuery.voyageNo === '' || this.listQuery.voyageLeg === '') && (0, _validate.validateNull)(this.listQuery.blNo)) {
          callback(new Error(this.$t('exportCostSlipUpload.inputVvlOrDataTime')));
        } else {
          callback();
        }
      } else {
        // this.$refs.filterForm.validateField('dataTime')
        callback();
      }
    },
    validateBlNo: function validateBlNo(rule, value, callback) {
      if ((0, _validate.validateNull)(this.listQuery.blNo)) {
        if ((this.dataTime === null || this.dataTime.length === 0) && (0, _validate.validateNull)(this.listQuery.bkNo) && (this.listQuery.vesselCode === '' || this.listQuery.voyageNo === '' || this.listQuery.voyageLeg === '')) {
          callback(new Error(this.$t('exportCostSlipUpload.inputVvlOrDataTime')));
        } else {
          callback();
        }
      } else {
        // this.$refs.filterForm.validateField('dataTime')
        callback();
      }
    },
    validateDataTime: function validateDataTime(rule, value, callback) {
      if (this.dataTime === null || this.dataTime.length === 0) {
        if ((this.listQuery.vesselCode === '' || this.listQuery.voyageNo === '' || this.listQuery.voyageLeg === '') && (0, _validate.validateNull)(this.listQuery.bkNo) && (0, _validate.validateNull)(this.listQuery.blNo)) {
          this.$refs.filterForm.validateField('vvl');
          callback(new Error(this.$t('exportCostSlipUpload.inputVvlOrDataTime')));
        } else {
          callback();
        }
      } else {
        // this.$refs.filterForm.validateField('vvl')
        callback();
      }
    }
  }
};